import React from "react";

function gettable3(state){

    const criticalNDT = ["ndt8", "ndt10", "ndt11", "ndt12", "ndt13"];
    let source = "";
    let i = 0;
    let objID = "";
    let curSum = 1;
    let curNDT = 0;
    let result = [];
    for(let key in state.objects.ndt){
        objID = "obj" + (i+1);
        source += `Источник №${i+1} (труба от вращающейся печи "${state.objects.ndt[key].name.value}")`;
        for(let j = 0; j < criticalNDT.length; j++){
            console.log(criticalNDT[j]);
            console.log(objID);
            console.log(state.objects.ndt[objID].ndtres[criticalNDT[j]]);
            if(state.objects.ndt[objID].ndtres[criticalNDT[j]] !== "4"){
                curNDT += 1;
            }
        }
        result.push([i+1, source, curSum, curNDT, ""]);
        source = "";
        i = i + 1;
        curNDT = 0;
    }
    console.log(result);

    return result;

}

const dictionary = {
    ndt8: {
        name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909):',
        data: {
            "1":{
                name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909) для проектируемых технологических линий', 
                unit: 'мг/нм3',
                value: '≤ 25'
            },
            "2": {
                name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909) для технологических линий, введённых в эксплуатацию после 2008 года', 
                unit: 'мг/нм3',
                value: '≤ 50 '
            },
            "3": {
                name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909) для технологических линий, введённых в эксплуатацию до 2008 года с модернизированными фильтрами', 
                unit: 'мг/нм3',
                value: '≤ 500 '
            },
            "4": {
                name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909) для технологических линий, введённых в эксплуатацию до 2008 года', 
                unit: 'мг/нм3',
                value: '≤ 1000 '
            },
        }
        
    },

    ndt10: {
        data: {
            "1": {
                name: 'Выбросы оксидов азота NOx из вращающейся печи для печей с циклонным теплообменником',
                unit: 'мг/нм3',
                value: '≤ 500'
            },
            "2": {
                name: 'Выбросы оксидов азота NOx из вращающейся печи для длинных печей мокрого способа производства и печей Леполь',
                unit: 'мг/нм3',
                value: '≤ 800'
            },
            "3": {
                name: 'Выбросы оксидов азота NOx из вращающейся печи для печей с циклонным теплообменником',
                unit: 'мг/нм3',
                value: '≤ 500'
            }
        },
        comm: 'Среднее арифметическое за время проведения замеров'

    },

    ndt11: {
        data: {
            "1": {
                name: 'Проскок NH3',
                unit: 'мг/нм3',
                value: '30-50 '
            }
        },
    },
    ndt12: {
        data: {
            "1": {
                name: 'Выбросы диоксида серы SO2 из вращающейся печи (код ЗВ 0330)',
                unit: 'мг/нм3',
                value: '≤ 400'
            }
        },
        comm: 'Среднее арифметическое за время проведения замеров'
    },
    ndt13: {
        data: {
            "1": {
                name: 'Выбросы оксида углерода CO из вращающейся печи (код ЗВ 0337',
                unit: 'мг/нм3',
                value: '≤ 600'
            }
        },
        comm: '1) Среднее арифметическое за время проведения замеров'
    },
}

export default gettable3;
